<template>
  <div>
    <div class="i-layout-page-header">
      <div class="i-layout-page-header">
        <Button icon="ios-arrow-back" size="small" class="mr20" @click="$router.go(-1)">返回</Button>
        <span class="ivu-page-header-title mr20" v-text="$route.meta.title"></span>
      </div>
    </div>
    <Card :bordered="false" dis-hover class="ivu-mt">
      <Form ref="infoData" :model='infoData' label-position="right" :label-width="200"
            @submit.native.prevent>
        <Row :gutter="24" type="flex">

          <Col span="24">
            <FormItem label="状态" prop="status_msg">
              <Input disabled="disabled" class="perW30" v-model="infoData.status_msg"></Input>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="牛只类别" prop="cattle_type_name">
              <Input disabled="disabled" class="perW30" v-model="infoData.cattle_type_name"></Input>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="牛只品种" prop="cattle_variety_name">
              <Input disabled="disabled" class="perW30" v-model="infoData.cattle_variety_name"></Input>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="耳标编号" prop="tag_sn">
              <Input disabled="disabled" class="perW30" v-model="infoData.tag_sn"></Input>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="寄养/回收人姓名" prop="name">
              <Input disabled="disabled" class="perW30" v-model="infoData.name"></Input>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="联系电话" prop="phone">
              <Input disabled="disabled" class="perW30" v-model="infoData.phone"></Input>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="地址" prop="address">
              <Input disabled="disabled" class="perW60" v-model="infoData.address"></Input>
            </FormItem>
          </Col>

          <Col span="24" v-if="infoData.status == 2">
            <FormItem label="回收圈舍" prop="cattle_house_name">
              <Input disabled="disabled" class="perW30" v-model="infoData.cattle_house_name"></Input>
            </FormItem>
          </Col>

        </Row>

      </Form>
    </card>

  </div>
</template>
<script>
import {cattleBreedFosterDetailApi} from '@/api/cattleFarm/cattleBreedFoster'

export default {
  name: 'cattleBreedFosterInfo',
  data() {
    return {
      infoData: {
        cattle_breed_foster_id: 0,
        cattle_type_name: '',
        cattle_variety_name: '',
        tag_sn: '',
        name: '',
        phone: '',
        address: '',
        cattle_house_name: '',
        status_msg: '',
      },
    }
  },
  mounted() {
    if (this.$route.params.id !== '0' && this.$route.params.id) {
      this.loadInfoData(this.$route.params.id)
    }
  },
  methods: {
    // 加载数据
    loadInfoData(id) {
      cattleBreedFosterDetailApi(id).then(res => {
        //数据赋值
        this.infoData = res.data

      }).catch(res => {
        this.$Message.error(res.msg)
      })
    },
  }
}
</script>
